import { Transaction } from './supabase';

export type LedgerTransactionLike = {
  debit_amount?: number;
  credit_amount?: number;
  status?: string;
  transaction_type?: string;
};

export const calculateBalanceFromTransactions = (transactions: LedgerTransactionLike[] = []) => {
  return (transactions || [])
    .filter((t) => !t.status || t.status === 'posted')
    .reduce((sum, t) => {
      const debit = Number(t.debit_amount || 0);
      const credit = Number(t.credit_amount || 0);
      return sum + debit - credit;
    }, 0);
};

export const calculateBalanceFromTransaction = (transaction: LedgerTransactionLike) => {
  return Number(transaction.debit_amount || 0) - Number(transaction.credit_amount || 0);
};

export const getBalanceStatus = (balance: number = 0) => {
  if (balance > 0) return 'Outstanding';
  if (balance < 0) return 'In Credit';
  return 'Paid';
};

export const getBalanceColorClass = (balance: number = 0) => {
  if (balance > 0) return 'text-red-600';
  if (balance < 0) return 'text-green-600';
  return 'text-gray-600';
};

export const accountBalanceFromTransactions = (transactions: Transaction[] = []) => {
  return calculateBalanceFromTransactions(transactions as LedgerTransactionLike[]);
};
